export function requiereOtpCierre(estado, esTai, config) {
  return ['Finalizado', 'Fallido'].includes(estado) &&
    Boolean(esTai ? config.tai_validacion_sms_activo : config.otp_traslados_normales_activo);
}
